(function() {
  // Gewichten in gram, bedragen in centen
  // Pas hier je tarieven aan als ze anders zijn
  var RULES = {
    "NL": {
      freeOver: null, // zet bv 5000 voor gratis vanaf €50
      brackets: [
        { maxG: 99,    priceCents: 250 }, // 0–99 g → €2,50
        { maxG: 250,   priceCents: 350 }, // 100–250 g → €3,50
        { maxG: 30000, priceCents: 595 }  // 251 g–30 kg → €5,95
      ]
    },
    "BE": {
      freeOver: null,
      brackets: [
        { maxG: 30000, priceCents: 1295 } // vast tarief €12,95
      ]
    },
    "EU": {
      freeOver: null,
      brackets: [
        { maxG: 30000, priceCents: 1295 } // vast tarief €12,95
      ]
    }
  };

  function formatMoney(cents, currency) {
    var val = (cents / 100).toFixed(2).replace('.', ',');
    return currency === 'EUR' ? '€' + val : val + ' ' + currency;
  }

  function calcRate(country, weightG, subtotalCents) {
    var r = RULES[country];
    if (!r) return null;
    if (typeof r.freeOver === 'number' && subtotalCents >= r.freeOver) return 0;
    for (var i = 0; i < r.brackets.length; i++) {
      if (weightG <= r.brackets[i].maxG) return r.brackets[i].priceCents;
    }
    return null;
  }

  function readNums() {
    var root = document.getElementById('tc-shipping-estimate');
    if (!root) return null;
    return {
      weightG: parseInt(root.getAttribute('data-cart-weight'), 10) || 0,
      subtotalCents: parseInt(root.getAttribute('data-cart-subtotal'), 10) || 0,
      currency: root.getAttribute('data-currency') || 'EUR'
    };
  }

  function updateText() {
    var n = readNums();
    if (!n) return;
    var countryEl = document.getElementById('tc-country');
    if (!countryEl) return;
    var country = countryEl.value;
    var price = calcRate(country, n.weightG, n.subtotalCents);
    var el = document.getElementById('tc-shipping-text');
    if (!el) return;

    if (price === 0) {
      el.textContent = 'Verzendkosten: gratis';
    } else if (typeof price === 'number') {
      el.textContent = 'Verzendkosten: ' + formatMoney(price, n.currency);
    } else {
      el.textContent = 'Verzendkosten: niet beschikbaar. Controleer productgewichten.';
    }
  }

  document.addEventListener('change', function(e) {
    if (e.target && e.target.id === 'tc-country') updateText();
  });

  document.addEventListener('DOMContentLoaded', updateText);
  document.addEventListener('shopify:section:load', updateText);
})();
